import { render } from "./ProspectSameAddress.vue?vue&type=template&id=69a7ebbc"
import script from "./ProspectSameAddress.vue?vue&type=script&lang=js"
export * from "./ProspectSameAddress.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__